// WaveSurfer hook. Allows WaveSurfer to be initialized as a function
// This is part of the react wrapper for the WaveSurfer library.
//See: https://wavesurfer-js.org/examples/#react.js

import { useEffect, useState } from "react";
import WaveSurfer from "./wavesurfer/wavesurfer.ts";

export const useWavesurfer = (containerRef, options) => {
  const [wavesurfer, setWavesurfer] = useState(null);

  // Initialize wavesurfer when the container mounts
  // or any of the props change
  useEffect(() => {
    if (!containerRef.current) return;

    const ws = WaveSurfer.create({
      ...options,
      container: containerRef.current,
    });

    setWavesurfer(ws);
    ws.zoomValue = 0;

    return () => {
      ws.destroy();
    };
  }, [options, containerRef]);

  return wavesurfer;
};
